import Utils from "@/utilities/Utils";
import { mapData } from "@/utilities/DataMapping";
import { ISouthEasternPersonFieldSet, SouthEasternPersonFieldSet } from "@/model/workPermits/SouthEasternPersonFieldSet";
import { ISwmScapaPersonFieldSet, SwmScapaPersonFieldSet } from "@/model/workPermits/SwmScapaPersonFieldSet";

export interface IWorkPermitPerson {
    id: string;
    workPermitID: string;
    visitID: string;
    copiedFromID: string;
    isMain: boolean;
    name: string;
    email: string;
    phone: string;
    visitCode: string;
    southEasternFieldSet: ISouthEasternPersonFieldSet;
    swmScapaFieldSet: ISwmScapaPersonFieldSet;
}

export class WorkPermitPerson implements IWorkPermitPerson {

    constructor(data?: IWorkPermitPerson) {
        if (data) {
            this.update(data);
        }
        this.key = Utils.createKey(6);
    }

    update(data: IWorkPermitPerson): WorkPermitPerson {
        mapData(data, { root: () => this });
        return this;
    }

    key: string = ""; // just for v-for

    id: string = "";
    workPermitID: string = "";
    visitID: string = "";
    copiedFromID: string = "";
    isMain: boolean = false;
    name: string = "";
    email: string = "";
    phone: string = "";
    visitCode: string = "";
    visitIsCompleteAndPassed: boolean = false;

    southEasternFieldSet = new SouthEasternPersonFieldSet();
    swmScapaFieldSet = new SwmScapaPersonFieldSet();

    get isNew() {
        return Utils.isEmptyId(this.id);
    }

    // just used locally...
    plannedArrival: Date = new Date(Utils.emptyDateValue);
    isSelected: boolean = false;
}

